<template>
  <div id = "partners">
    <normal-header :data="header"/>
    <Partners/>
  </div>
</template>

<script>
import NormalHeader from '@/components/global-components/NormalHeader'
import Partners from '@/components/partners/Partners.vue'

export default  {
  components: {
    Partners,
    NormalHeader
  },
  data() {
    return {
      header: {
        transparent: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>